module.exports = __webpack_public_path__ + "img/p3.de82256d.png";